import React from 'react';
import TextCodeModal from './TextCodeModal';
import TextCodeExcerptsModal from './TextCodeExcerptsModal';

const CodeCard = ({ code, textCodes, setUploadAudioModal, handleUpdateCode, handleAddNewCode, t, ...rest }) => {
    const childCodes = textCodes.filter(c => c.parent === code.uuid);

    return (
        <div className='flex flex-col rounded-md px-4 py-4' style={{ backgroundColor: code.color }} data-testid={`code-card-${code.uuid}`} {...rest}>
            <span className='font-bold flex items-center gap-4' data-testid={`code-card-name-${code.uuid}`}>
                <div className='bg-black rounded-full text-white text-sm w-8 h-8 flex justify-center items-center' data-testid={`code-card-excerpt-count-${code.uuid}`}>
                    {code?.excerpts?.length || 0}
                </div>
                {code.name}
            </span>
            <span className='text-gray-700 text-sm mt-2' data-testid={`code-card-description-${code.uuid}`}>{code.description}</span>


            <div className='flex justify-end gap-4 mt-4'>
                <button className='bg-white text-black rounded-md px-4 py-2 text-sm'
                    data-testid={`code-card-edit-btn-${code.uuid}`}
                    onClick={() => setUploadAudioModal(
                        <TextCodeModal
                            code={code}
                            handleClose={() => setUploadAudioModal(null)}
                            handleUpdateCode={handleUpdateCode}
                            handleAddNewCode={handleAddNewCode}
                            textCodes={textCodes}
                        />
                    )}>
                    {t('DetailProjects.Edit')}
                </button>
                <button className='bg-black text-white rounded-md px-4 py-2 text-sm'
                    data-testid={`code-card-view-entries-btn-${code.uuid}`}
                    onClick={() => setUploadAudioModal(
                        <TextCodeExcerptsModal
                            handleClose={() => setUploadAudioModal(null)}
                            code={code}
                        />
                    )}>
                    {t('DetailProjects.View entries')}
                </button>
            </div>
            {childCodes.length > 0 && (
                <div className='ml-4 mt-4 space-y-2' data-testid={`code-card-children-${code.uuid}`}>
                    {childCodes.map(childCode => (
                        <div key={childCode.uuid}
                            className='flex flex-col rounded-md px-3 py-2 bg-opacity-90'
                            style={{ backgroundColor: childCode.color }}
                            data-testid={`child-code-card-${childCode.uuid}`}>
                            <span className='font-bold flex items-center gap-2' data-testid={`child-code-card-name-${childCode.uuid}`}>
                                <div className='bg-black rounded-full text-white text-xs w-6 h-6 flex justify-center items-center' data-testid={`child-code-card-excerpt-count-${childCode.uuid}`}>
                                    {childCode?.excerpts?.length || 0}
                                </div>
                                {childCode.name}
                            </span>
                            <span className='text-gray-700 text-sm mt-2' data-testid={`child-code-card-description-${childCode.uuid}`}>{childCode.description}</span>
                            <div className='flex justify-end gap-2'>
                                <button className='bg-white text-black rounded-md px-2 py-1 text-xs'
                                    data-testid={`child-code-card-edit-btn-${childCode.uuid}`}
                                    onClick={() => setUploadAudioModal(
                                        <TextCodeModal
                                            code={childCode}
                                            handleClose={() => setUploadAudioModal(null)}
                                            handleUpdateCode={handleUpdateCode}
                                            handleAddNewCode={handleAddNewCode}
                                            textCodes={textCodes}
                                        />
                                    )}>
                                    {t('DetailProjects.Edit')}
                                </button>
                                <button className='bg-black text-white rounded-md px-2 py-1 text-xs'
                                    data-testid={`child-code-card-view-entries-btn-${childCode.uuid}`}
                                    onClick={() => setUploadAudioModal(
                                        <TextCodeExcerptsModal
                                            handleClose={() => setUploadAudioModal(null)}
                                            code={childCode}
                                        />
                                    )}>
                                    {t('DetailProjects.View entries')}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

        </div>
    );
};

export default CodeCard;
